module.exports = __webpack_public_path__ + "static/media/id_card.27df5636.png";